<template>
  <v-img
    dark
    eager
    src="@/assets/images/about/ResourcesBG.jpg"
  >
    <v-overlay absolute opacity="0.2">
      <v-container>
        <v-row
          justify="center"
        >
          <v-col
            cols="12"
            class="text-center"
          >
            <h1 class="text-h4 mb-4 font-weight-medium">
              LOOKING FOR HELPFUL RESOURCES?
            </h1>
            <v-btn
              large
              rounded
              elevation="4"
              color="#F44D40"
              class="px-10 font-weight-regular"
            >
              <div style="color:white">SEE RESOURCES</div>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-overlay>
  </v-img>
</template>

<script>
export default {
  name: 'AboutResources'
}
</script>
